var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.stylist)?_c('div',{staticClass:"dark-footer"},[_c('action-bar')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }